import { Controller } from "@hotwired/stimulus"
import { createIcons, icons } from 'lucide'

export default class extends Controller {
  static targets = ["display", "input", "editButton", "saveButton", "cancelButton"]
  static values = { url: String }

  connect() {
    this.originalValue = this.inputTarget.value
    this.inputTarget.addEventListener('keydown', this.handleKeydown.bind(this))
    setTimeout(() => createIcons({ icons }), 0)
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.save()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancel()
    }
  }

  toggle() {
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.editButtonTarget.classList.add("hidden")
    this.saveButtonTarget.classList.remove("hidden")
    this.cancelButtonTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.hideEdit()
  }

  async save() {
    const newValue = this.inputTarget.value.trim()
    if (!newValue) {
      this.inputTarget.focus()
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ project: { title: newValue } })
      })

      if (response.ok) {
        this.originalValue = newValue
        this.displayTarget.textContent = `${newValue} Outline`
        this.hideEdit()
      } else {
        console.error('Failed to save')
      }
    } catch (error) {
      console.error('Error saving:', error)
    }
  }

  hideEdit() {
    this.displayTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")
    this.editButtonTarget.classList.remove("hidden")
    this.saveButtonTarget.classList.add("hidden")
    this.cancelButtonTarget.classList.add("hidden")
    setTimeout(() => createIcons({ icons }), 0)
  }
}
